import React, {useContext} from 'react';
import FormContext from "formContext";
import axios from 'axios';
import GetRouteByName from 'getRouteByName';
import { pushCandidateEvent } from "dataLayerHelper";
import {useRouteMatch} from "react-router-dom";

const useRegisterSubmitHandler = () => {
  const {formData, handleErrors, currentStep, setLoading, additionalData} = useContext(FormContext);
  const { branches } = additionalData;
  const registerConfirmationUrl = GetRouteByName('register-confirmation').url;
  const values = formData[currentStep];
  const currentUrl = useRouteMatch().url;
  const data_warehouse = {
    specialismId: null,
    branchId: null,
    divisionId: null,
    divisionName: null,
    dovaCompanyId: null,
    dovaCompanyName: null,
    location: currentUrl,
  };

  if (values && branches && branches[values.branch_specialism]) {
    data_warehouse.specialismId = branches[values.branch_specialism].specialismId;
    data_warehouse.divisionId = branches[values.branch_specialism].divisionId;
    data_warehouse.divisionName = branches[values.branch_specialism].divisionName;
    data_warehouse.dovaCompanyId = branches[values.branch_specialism].dovaId;
    data_warehouse.dovaCompanyName = branches[values.branch_specialism].dovaName;
    if (branches[values.branch_specialism].children[values.local_branch]) {
      data_warehouse.branchId = branches[values.branch_specialism].children[values.local_branch].branchId;
    }
  }
  const handleRegisterSubmit = () => {
    setLoading(true);
    // Fetch saved jobs.
    const favoriteJobs = JSON.parse(localStorage.getItem("favJobs"));
    if (favoriteJobs) {
      values.savedJobs = favoriteJobs;
    }

    if (formData[currentStep] && captcha?.getToken('mrnd_captcha')) {
      formData[currentStep].captchaToken = captcha?.getToken('mrnd_captcha');
    }

    axios.post(`${process.env.REACT_APP_API_PREFIX}/signup`, { ...values, data_warehouse })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          pushCandidateEvent("register");

          window.location = registerConfirmationUrl;
          setLoading(false);
          captcha?.reset('mrnd_captcha');
        }
      })
      .catch(error => {
        handleErrors(error.response.data);
        setLoading(false);
        captcha?.reset('mrnd_captcha');
      });
  }

  return {
    handleRegisterSubmit
  }
};

export default useRegisterSubmitHandler;
